export const GET_PRODUCTS_LIST = 'pam/GET_PRODUCTS_LIST'
export const GET_PRODUCTS_LIST_SUCCESS = 'pam/GET_PRODUCTS_LIST_SUCCESS'
export const GET_PRODUCTS_LIST_FAIL = 'pam/GET_PRODUCTS_LIST_FAIL'

export const ADD_PRICE = 'pam/ADD_PRICE'
export const ADD_PRICE_SUCCESS = 'pam/ADD_PRICE_SUCCESS'
export const ADD_PRICE_FAIL = 'pam/ADD_PRICE_FAIL'

export const GET_RETAILERS_LIST = 'pam/GET_RETAILERS_LIST'
export const GET_RETAILERS_LIST_SUCCESS = 'pam/GET_RETAILERS_LIST_SUCCESS'
export const GET_RETAILERS_LIST_FAIL = 'pam/GET_RETAILERS_LIST_FAIL'
export const GET_RETAILERS_LIST_V2 = 'pam/GET_RETAILERS_LIST_V2'
export const GET_RETAILERS_LIST_V2_SUCCESS = 'pam/GET_RETAILERS_LIST_V2_SUCCESS'
export const GET_RETAILERS_LIST_V2_FAIL = 'pam/GET_RETAILERS_LIST_V2_FAIL'

export const GET_OCR_RETAILERS_LIST = 'pam/GET_OCR_RETAILERS_LIST'
export const GET_OCR_RETAILERS_LIST_SUCCESS = 'pam/GET_OCR_RETAILERS_LIST_SUCCESS'
export const GET_OCR_RETAILERS_LIST_FAIL = 'pam/GET_OCR_RETAILERS_LIST_FAIL'

export const GET_SAME_PRODUCTS = 'pam/GET_SAME_PRODUCTS'
export const GET_SAME_PRODUCTS_SUCCESS = 'pam/GET_SAME_PRODUCTS_SUCCESS'
export const GET_SAME_PRODUCTS_FAIL = 'pam/GET_SAME_PRODUCTS_FAIL'
export const DELETE_SIMILAR = 'pam/DELETE_SIMILAR'

export const GET_PRICES = 'pam/GET_PRICES'
export const GET_PRICES_SUCCESS = 'pam/GET_PRICES_SUCCESS'
export const GET_PRICES_FAIL = 'pam/GET_PRICES_FAIL'

export const ADD_PRODUCT = 'pam/ADD_PRODUCT'
export const ADD_PRODUCT_SUCCESS = 'pam/ADD_PRODUCT_SUCCESS'
export const ADD_PRODUCT_FAIL = 'pam/ADD_PRODUCT_FAIL'

export const UPDATE_PRODUCT = 'pam/UPDATE_PRODUCT'
export const UPDATE_PRODUCT_SUCCESS = 'pam/UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_FAIL = 'pam/UPDATE_PRODUCT_FAIL'

export const DELETE_PRODUCT = 'pam/DELETE_PRODUCT'
export const DELETE_PRODUCT_SUCCESS = 'pam/DELETE_PRODUCT_SUCCESS'
export const DELETE_PRODUCT_FAIL = 'pam/DELETE_PRODUCT_FAIL'

export const UPDATE_SAME_PRODUCT = 'pam/UPDATE_SAME_PRODUCT'
export const UPDATE_SAME_PRODUCT_SUCCESS = 'pam/UPDATE_SAME_PRODUCT_SUCCESS'
export const UPDATE_SAME_PRODUCT_FAIL = 'pam/UPDATE_SAME_PRODUCT_FAIL'

export const SEARCH_GTIN = 'pam/SEARCH_GTIN'
export const SEARCH_GTIN_SUCCESS = 'pam/SEARCH_GTIN_SUCCESS'
export const SEARCH_GTIN_FAIL = 'pam/SEARCH_GTIN_FAIL'

export const SEARCH_STORE_ID = 'pam/SEARCH_STORE_ID'
export const SEARCH_STORE_ID_SUCCESS = 'pam/SEARCH_STORE_ID_SUCCESS'
export const SEARCH_STORE_ID_FAIL = 'pam/SEARCH_STORE_ID_FAIL'

export const GET_RETAILER_BRANDS = 'pam/GET_RETAILER_BRANDS'
export const GET_RETAILER_BRANDS_SUCCESS = 'pam/GET_RETAILER_BRANDS_SUCCESS'
export const GET_RETAILER_BRANDS_FAIL = 'pam/GET_RETAILER_BRANDS_FAL'

export const UPDATE_PRICE = 'pam/UPDATE_PRICE'
export const UPDATE_PRICE_SUCCESS = 'pam/UPDATE_PRICE_SUCCESS'
export const UPDATE_PRICE_FAIL = 'pam/UPDATE_PRICE_FAIL'

export const SET_CURRENT_RETAILER = 'pam/SET_CURRENT_RETAILER'
export const SET_CURRENT_OCR_RETAILER = 'pam/SET_CURRENT_OCR_RETAILER'
export const UPDATE_EDITED_PRODUCT = 'pam/UPDATE_EDITED_PRODUCT'

export const GET_PARTICIPANTS = 'pam/GET_PARTICIPANTS'
export const GET_PARTICIPANTS_SUCCESS = 'pam/GET_PARTICIPANTS_SUCCESS'
export const GET_PARTICIPANTS_FAIL = 'pam/GET_PARTICIPANTS_FAIL'

export const SET_CHECKED_RETALER = 'pam/SET_CHECKED_RETALER'
export const CLEAR_GTIN_ERROR = 'pam/CLEAR_GTIN_ERROR'

export const EXPORT_PRODUCTS = 'pam/EXPORT_PRODUCTS'
export const EXPORT_PRODUCTS_SUCCESS = 'pam/EXPORT_PRODUCTS_SUCCESS'
export const EXPORT_PRODUCTS_FAIL = 'pam/EXPORT_PRODUCTS_FAIL'

export const GET_EXPORT_LINK = 'pam/GET_EXPORT_LINK'
export const GET_EXPORT_LINK_SUCCESS = 'pam/GET_EXPORT_LINK_SUCCESS'
export const GET_EXPORT_LINK_FAIL = 'pam/GET_EXPORT_LINK_FAIL'

export const CLEAR_DOWNLOAD_LINK = 'pam/CLEAR_DOWNLOAD_LINK'

export const IMPORT_PRODUCTS = 'pam/IMPORT_PRODUCTS'
export const IMPORT_PRODUCTS_SUCCESS = 'pam/IMPORT_PRODUCTS_SUCCESS'
export const IMPORT_PRODUCTS_FAIL = 'pam/IMPORT_PRODUCTS_FAIL'

export const GET_IMPORT_STATUS = 'pam/GET_IMPORT_STATUS'
export const GET_IMPORT_STATUS_SUCCESS = 'pam/GET_IMPORT_STATUS_SUCCESS'
export const GET_IMPORT_STATUS_FAIL = 'pam/GET_IMPORT_STATUS_FAIL'

export const IMPORT_SAME_PRODUCTS = 'pam/IMPORT_SAME_PRODUCTS'
export const IMPORT_SAME_PRODUCTS_SUCCESS = 'pam/IMPORT_SAME_PRODUCTS_SUCCESS'
export const IMPORT_SAME_PRODUCTS_FAIL = 'pam/IMPORT_SAME_PRODUCTS_FAIL'

export const GET_SPG_LIST = 'pam/GET_SPG_LIST'
export const GET_SPG_LIST_SUCCESS = 'pam/GET_SPG_LIST_SUCCESS'
export const GET_SPG_LIST_FAIL = 'pam/GET_SPG_LIST_FAIL'

export const PAM_SET_ITEM_VALUE = 'pam/SET_ITEM_VALUE'

export const pamGetProductsList = payload => ({
  type: GET_PRODUCTS_LIST,
  payload
})

export const pamGetProductsListSuccess = payload => ({
  type: GET_PRODUCTS_LIST_SUCCESS,
  payload
})

export const pamGetProductsListFail = payload => ({
  type: GET_PRODUCTS_LIST_FAIL,
  payload
})

export const pamGetRetailersListV2 = payload => ({
  type: GET_RETAILERS_LIST_V2,
  payload
})

export const pamGetRetailersList = payload => ({
  type: GET_RETAILERS_LIST,
  payload
})

export const pamGetRetailersListSuccess = payload => ({
  type: GET_RETAILERS_LIST_SUCCESS,
  payload
})

export const pamGetRetailersListFail = payload => ({
  type: GET_RETAILERS_LIST_FAIL,
  payload
})

export const pamGetRetailersListV2Success = payload => ({
  type: GET_RETAILERS_LIST_V2_SUCCESS,
  payload
})

export const pamGetRetailersListV2Fail = payload => ({
  type: GET_RETAILERS_LIST_V2_FAIL,
  payload
})

export const pamGetOCRRetailersList = payload => ({
  type: GET_OCR_RETAILERS_LIST,
  payload
})

export const pamGetOCRRetailersListSuccess = payload => ({
  type: GET_OCR_RETAILERS_LIST_SUCCESS,
  payload
})

export const pamGetOCRRetailersListFail = payload => ({
  type: GET_OCR_RETAILERS_LIST_FAIL,
  payload
})

export const pamGetSameProducts = payload => ({
  type: GET_SAME_PRODUCTS,
  payload
})

export const pamDeleteSimilar = payload => ({
  type: DELETE_SIMILAR,
  payload
})

export const pamGetSameProductsSuccess = payload => ({
  type: GET_SAME_PRODUCTS_SUCCESS,
  payload
})

export const pamGetSameProductsFail = payload => ({
  type: GET_SAME_PRODUCTS_FAIL,
  payload
})

export const pamGetPrices = payload => ({
  type: GET_PRICES,
  payload
})

export const pamGetPricesSuccess = payload => ({
  type: GET_PRICES_SUCCESS,
  payload
})

export const pamGetPricesFail = payload => ({
  type: GET_PRICES_FAIL,
  payload
})

export const pamAddProduct = payload => ({
  type: ADD_PRODUCT,
  payload
})

export const pamAddProductSuccess = payload => ({
  type: ADD_PRODUCT_SUCCESS,
  payload
})

export const pamAddProductFail = payload => ({
  type: ADD_PRODUCT_FAIL,
  payload
})

export const pamUpdateProduct = payload => ({
  type: UPDATE_PRODUCT,
  payload
})

export const pamUpdateProductSuccess = payload => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload
})

export const pamUpdateProductFail = payload => ({
  type: UPDATE_PRODUCT_FAIL,
  payload
})

export const pamUpdateSameProduct = payload => ({
  type: UPDATE_SAME_PRODUCT,
  payload
})

export const pamUpdateSameProductSuccess = payload => ({
  type: UPDATE_SAME_PRODUCT_SUCCESS,
  payload
})

export const pamUpdateSameProductFail = payload => ({
  type: UPDATE_SAME_PRODUCT_FAIL,
  payload
})

export const pamSearchGtin = payload => ({
  type: SEARCH_GTIN,
  payload
})

export const pamSearchGtinSuccess = payload => ({
  type: SEARCH_GTIN_SUCCESS,
  payload
})

export const pamSearchGtinFail = payload => ({
  type: SEARCH_GTIN_FAIL,
  payload
})

export const pamDeleteProduct = payload => ({
  type: DELETE_PRODUCT,
  payload
})

export const pamDeleteProductSuccess = payload => ({
  type: DELETE_PRODUCT_SUCCESS,
  payload
})

export const pamDeleteProductFail = payload => ({
  type: DELETE_PRODUCT_FAIL,
  payload
})

export const pamGetRetailersBrands = payload => ({
  type: GET_RETAILER_BRANDS,
  payload
})

export const pamGetRetailersBrandsSuccess = payload => ({
  type: GET_RETAILER_BRANDS_SUCCESS,
  payload
})

export const pamGetRetailersBrandsFail = payload => ({
  type: GET_RETAILER_BRANDS_FAIL,
  payload
})

export const pamSetCurrentRetailer = payload => ({
  type: SET_CURRENT_RETAILER,
  payload
})

export const pamSetCurrentOCRRetailer = payload => ({
  type: SET_CURRENT_OCR_RETAILER,
  payload
})

export const pamUpdatePrice = payload => ({
  type: UPDATE_PRICE,
  payload
})

export const pamUpdatePriceSuccess = payload => ({
  type: UPDATE_PRICE_SUCCESS,
  payload
})

export const pamUpdatePriceFail = payload => ({
  type: UPDATE_PRICE_FAIL,
  payload
})

export const pamUpdateEditedProduct = payload => ({
  type: UPDATE_EDITED_PRODUCT,
  payload
})

export const pamGetParticipants = payload => ({
  type: GET_PARTICIPANTS,
  payload
})

export const pamGetParticipantsSuccess = payload => ({
  type: GET_PARTICIPANTS_SUCCESS,
  payload
})

export const pamGetParticipantsFail = payload => ({
  type: GET_PARTICIPANTS_FAIL,
  payload
})

export const pamSetCheckedRetailer = payload => ({
  type: SET_CHECKED_RETALER,
  payload
})

export const pamClearGtinError = payload => ({
  type: CLEAR_GTIN_ERROR,
  payload
})

export const pamExportProducts = payload => ({
  type: EXPORT_PRODUCTS,
  payload
})

export const pamExportProductsSuccess = payload => ({
  type: EXPORT_PRODUCTS_SUCCESS,
  payload
})

export const pamExportProductsFail = payload => ({
  type: EXPORT_PRODUCTS_FAIL,
  payload
})

export const pamGetExportLink = payload => ({
  type: GET_EXPORT_LINK,
  payload
})

export const pamGetExportLinkSuccess = payload => ({
  type: GET_EXPORT_LINK_SUCCESS,
  payload
})

export const pamGetExportLinkFail = payload => ({
  type: GET_EXPORT_LINK_FAIL,
  payload
})

export const pamClearDownloadLink = payload => ({
  type: CLEAR_DOWNLOAD_LINK,
  payload
})

export const pamImportProducts = payload => ({
  type: IMPORT_PRODUCTS,
  payload
})

export const pamImportProductsSuccess = payload => ({
  type: IMPORT_PRODUCTS_SUCCESS,
  payload
})

export const pamImportProductsFail = payload => ({
  type: IMPORT_PRODUCTS_FAIL,
  payload
})

export const pamGetImportStatus = payload => ({
  type: GET_IMPORT_STATUS,
  payload
})

export const pamGetImportStatusSuccess = payload => ({
  type: GET_IMPORT_STATUS_SUCCESS,
  payload
})

export const pamGetImportStatusFail = payload => ({
  type: GET_IMPORT_STATUS_FAIL,
  payload
})

export const pamImportSameProducts = payload => ({
  type: IMPORT_SAME_PRODUCTS,
  payload
})

export const pamImportSameProductsSuccess = payload => ({
  type: IMPORT_SAME_PRODUCTS_SUCCESS,
  payload
})

export const pamImportSameProductsFail = payload => ({
  type: IMPORT_SAME_PRODUCTS_FAIL,
  payload
})

export const pamAddPrice = payload => ({
  type: ADD_PRICE,
  payload
})

export const pamAddPriceSuccess = payload => ({
  type: ADD_PRICE_SUCCESS,
  payload
})

export const pamAddPriceFail = payload => ({
  type: ADD_PRICE_FAIL,
  payload
})

export const pamSearchStoreId = payload => ({
  type: SEARCH_STORE_ID,
  payload
})

export const pamSearchStoreIdSuccess = payload => ({
  type: SEARCH_STORE_ID_SUCCESS,
  payload
})

export const pamSearchStoreIdFail = payload => ({
  type: SEARCH_STORE_ID_FAIL,
  payload
})

export const pamGetSPGList = payload => ({
  type: GET_SPG_LIST,
  payload
})

export const pamGetSPGListSuccess = payload => ({
  type: GET_SPG_LIST_SUCCESS,
  payload
})

export const pamGetSPGListFail = payload => ({
  type: GET_SPG_LIST_FAIL,
  payload
})

export const setItemValue = payload => ({
  type: PAM_SET_ITEM_VALUE,
  payload
})
